import React from 'react'
import styled from 'styled-components'
import { Button, Flex, Text, useModal } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import BoostCalculatorLink from 'views/Farms/components/BoostCalculatorLink'
import BoostFarmModal from 'views/Farms/components/BoostFarmModal'
import { Path } from 'config/constants/paths'
import { StyledTextWithUrl } from 'components/Text/StyledTextWithUrl'

const Wrapper = styled.div`
  padding: 24px;
  background: linear-gradient(90deg, #002966 0%, #9476bd 75.91%, #be8e96 100%);
`

const Container = styled(Flex)`
  border: 2px solid ${({ theme }) => theme.colors.outline};
  padding: 16px;
  border-radius: 16px;
  background: ${({ theme }) => theme.colors.input};
`

interface FarmCardActionsProps {
  farmId?: number
  xVVSStaked?: boolean
}

const BoostAction: React.FC<FarmCardActionsProps> = ({ farmId, xVVSStaked = false }) => {
  const { t } = useTranslation()
  const { theme } = useTheme()
  const [onPresentBoostFarmModal] = useModal(<BoostFarmModal targetFarmId={farmId} />)

  const clickButton = async () => {
    onPresentBoostFarmModal()
  }

  return (
    <Wrapper>
      <Container flexDirection="column" gap="12px">
        {!xVVSStaked ? (
          <StyledTextWithUrl
            linkColor="primary"
            fontSize="13px"
            dangerouslySetInnerHTML={{
              __html: t('You need to %openUrlTag%deposit xVVS%closeUrlTag% before boosting this farm', {
                openUrlTag: `<a href="${Path.XVVS_VAULT_BOOST}">`,
                closeUrlTag: '</a>',
              }),
            }}
          />
        ) : (
          <Text bold>{t('Boost your farm to enjoy higher APR today')}</Text>
        )}
        <BoostCalculatorLink color={theme.colors.primary} farmId={farmId} />
        <Button disabled={!xVVSStaked} onClick={clickButton}>
          {t('Boost this Farm')}
        </Button>
      </Container>
    </Wrapper>
  )
}

export default BoostAction
